import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip02',
  imgSrc: 'card/template/vip01/cardTemplateVip02.png',
  desc: '旋转独角仙',
  category: 'card',
  vipGrade: 1,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/2.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/beetle.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
